import { render } from "./start-quiz.vue?vue&type=template&id=38a95b55&scoped=true"
import script from "./start-quiz.vue?vue&type=script&lang=js"
export * from "./start-quiz.vue?vue&type=script&lang=js"

import "./start-quiz.vue?vue&type=style&index=0&id=38a95b55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a95b55"]])

export default __exports__